<template>
  <div>
      <span class='current' v-b-tooltip.hover.right title="Current Value">{{currentValue}}</span>
      <br>
      <span class='delta' :class="deltaClass"><i :class="deltaArrow"></i> {{deltaString}}</span>
      <br>
      <span class='old-value' v-b-tooltip.hover.right title="Compared Value">{{oldValue}}</span>
  </div>
</template>
<script>
import Moment from 'moment'

export default {
  name: 'CompareValues',
  props: ['label', 'currentValue', 'oldValue'],
  data () {
    return {
      delta: 0
    }
  },
  created () {
    this.delta = this.calcDelta()
  },
  updated () {
    this.delta = this.calcDelta()
  },
  methods: {
    calcDelta () {
      var newCurrent, newOld
      if ((typeof this.currentValue === 'string' || this.currentValue instanceof String) && (typeof this.oldValue === 'string' || this.oldValue instanceof String)) {
        if (this.currentValue.includes('%') && this.oldValue.includes('%')) {
          newCurrent = parseFloat(this.currentValue.replace(/\/%/g, '/'))
          newOld = parseFloat(this.oldValue.replace(/\/%/g, '/'))
        } else if (this.currentValue.includes('$')) {
          newCurrent = parseFloat(this.currentValue.replace(/,/g, '').substr(1))
          newOld = parseFloat(this.oldValue.replace(/,/g, '').substr(1))
        } else if (this.currentValue.includes(':')){
          var currentMoment = Moment(this.currentValue, 'HH:mm:ss')
          var currentHours = parseInt(currentMoment.format('HH'))
          var currentMinutes = parseInt(currentMoment.format('mm'))
          var currentSeconds = parseInt(currentMoment.format('ss'))
          newCurrent = (currentHours * 3600) + (currentMinutes * 60) + currentSeconds
          var oldMoment = Moment(this.oldValue, 'HH:mm:ss')
          var oldHours = parseInt(oldMoment.format('HH'))
          var oldMinutes = parseInt(oldMoment.format('mm'))
          var oldSeconds = parseInt(oldMoment.format('ss'))
          newOld = (oldHours * 3600) + (oldMinutes * 60) + oldSeconds
        } else {
          newCurrent = parseFloat(this.currentValue)
          newOld = parseFloat(this.oldValue)
        }
      } else if ((typeof this.currentValue === 'string' || this.currentValue instanceof String) || (typeof this.oldValue === 'string' || this.oldValue instanceof String)) {
        if (this.currentValue.includes('%')) {
          newCurrent = parseFloat(this.currentValue.replace(/\/%/g, '/'))
          newOld = this.oldValue
        } else if (this.oldValue.includes('%')) {
          newOld = parseFloat(this.oldValue.replace(/\/%/g, '/'))
          newCurrent = this.currentValue
        } else {
          newCurrent = parseFloat(this.currentValue)
          newOld = parseFloat(this.oldValue)
        }
      } else {
        newCurrent = this.currentValue
        newOld = this.oldValue
      }
      if (newCurrent === 0 && newOld === 0) {
        return 0
      } else if (newCurrent !== 0 && newOld === 0) {
        return Number.POSITIVE_INFINITY
      } else if (newCurrent > newOld) {
        return (((newCurrent - newOld) / newOld) * 100).toFixed(2)
      } else {
        return (((newOld - newCurrent) / newOld) * -100).toFixed(2)
      }
    },
  },
  computed: {
    deltaString: function () {
      if (this.delta === 0) {
        return '0 %'
      } else if (isNaN(this.delta)) {
        return '-'
      } else if (this.delta === Number.POSITIVE_INFINITY) {
        return '∞ %'
      } else if (!isFinite(this.delta)) {
        return '-∞ %'
      } else {
        return `${this.delta} %`
      }
    },
    deltaClass: function () {
      if (this.label === 'avg_position') {
        return this.delta < 0 ? 'green' : 'red'
      } else {
        return this.delta > 0 ? 'green' : 'red'
      }

    },
    deltaArrow: function () {
      if (Math.round(this.delta) === 0) {
        return ''
      } else if (this.delta === Number.POSITIVE_INFINITY) {
        return "fa fa-caret-up"
      } else if (this.delta === Number.NEGATIVE_INFINITY) {
        return "fa-fa-caret-down"
      } else {
        return this.delta > 0 ? "fa fa-caret-up" : "fa fa-caret-down"
      }
    }
  }
}
</script>
<style scoped>
.old-value {
  color: #333;
  opacity: .6;
}
.current {
  font-weight: 600;
  font-size: 20px;
  color: #333;
}
.red {
 color: #C63F3F;
}

.green {
  color: #8DC63F;
}
.delta {
  font-size: 12px;
}

</style>
